import React from "react";
import moment from "moment";
import AllNflGamesHelper from "../../classes/allNflGamesHelper";
import { useHistory, useParams } from "react-router-dom";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useNflGamesForWeek from "../../hooks/queryResults/useNflGamesForWeek";
import NflUtil from "../../util/nflUtil";
import Util from "../../util/util";
import Loading from "../ui/Loading";

export default function NflGamesScoreboard() {
  const { league: leagueUrl, season, week: weekUrl } = useParams();
  const week = Util.weekFromUrl(weekUrl);
  const history = useHistory();
  const { nflGamesData, nflGamesQuery } = useNflGamesForWeek(season, week);

  const isLoading = useIsLoading(nflGamesData, nflGamesQuery);
  if (isLoading) return <Loading />;

  const allNflGamesHelper = new AllNflGamesHelper(nflGamesData);

  const nflGames = allNflGamesHelper.getWeekGames(week);

  console.log("nflGames", nflGames);

  const ahArray = ["away", "home"];

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexFlow: "row wrap",
        }}
      >
        {nflGames.map((nflGame, i) => {
          return (
            <div
              key={i}
              style={{
                margin: "0 1.25rem 0.75rem 0",
                width: "7rem",
              }}
              onClick={() => {
                const nflGameSlug = `${nflGame.teams.away.abbr}-${nflGame.teams.home.abbr}`;
                history.push(
                  `/${leagueUrl}/${season}/${weekUrl}/nfl/game/${nflGameSlug}`
                );
              }}
            >
              <div
                style={{
                  opacity: 0.75,
                  fontSize: "0.7rem",
                  whiteSpace: "nowrap",
                  marginBottom: "0.15rem",
                }}
              >
                {nflGame.startDate
                  ? moment(nflGame.startDate).format("ddd M/D h:mma")
                  : null}
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  color: "black",
                  cursor: "pointer",
                }}
              >
                {ahArray.map((ah, i) => {
                  const team = nflGame.teams[ah];

                  let abbr = NflUtil.formatNflTeamAbbr(team.abbr);

                  let record = null;
                  if (nflGame.hasEnded && team.recordAfter)
                    record = team.recordAfter;
                  else if (team.recordBefore) record = team.recordBefore;

                  if (record)
                    record = (
                      <div
                        style={{
                          fontSize: "0.5rem",
                          color: "#333",
                          marginLeft: "0.25rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        ({record})
                      </div>
                    );

                  let scoreOrVegas = null;
                  if (team.hasOwnProperty("score")) {
                    scoreOrVegas = team.score;
                  } else if (team.hasOwnProperty("spread")) {
                    if (team.spread < 0) scoreOrVegas = team.spread;
                  }

                  const backgroundColor =
                    team.result === "W" ? "#ccdfff" : "#fff";

                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "0.25rem 0.5rem",
                        backgroundColor,
                      }}
                    >
                      <div>{abbr}</div>
                      {record}
                      <div
                        style={{
                          marginLeft: "0.5rem",
                          textAlign: "right",
                          flexGrow: 3,
                        }}
                      >
                        {scoreOrVegas}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
